import { render, staticRenderFns } from "./folders-vessels-option-charteres-files.vue?vue&type=template&id=7f04a18b&scoped=true"
import script from "./folders-vessels-option-charteres-files.vue?vue&type=script&lang=js"
export * from "./folders-vessels-option-charteres-files.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f04a18b",
  null
  
)

export default component.exports